import { axios } from '../utils'
import { Certification } from 'common/types/entities/api/certification'

export const fetchCertification = async (certificationNo: string): Promise<Certification> => {
  const result = await axios.get<Certification>(`/v1/certifications/${certificationNo}`)
  return result && result.data
}
